import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { useMediaQuery } from '@/composables/useMediaQuery'
import useAdConfigurationGlobals from '@/composables/useAdConfigurationGlobals';

const { $GPT_PRIMARY_ACTIVITY, $AD_SOURCE, $AD_SLOT_INFO } = useAdConfigurationGlobals();

export let useAdStore = defineStore('adStore', () => {
  const isDesktop = useMediaQuery('(min-width: 840px)');

  const adSlots = new Map();

  const refreshAllowed = ref(true);

  const getAdSlot = computed(() => adId => adSlots.value[adId]);
  
  const primaryActivity = computed(() => $GPT_PRIMARY_ACTIVITY)
  const isAdsense = computed(() => $AD_SOURCE === 'adsense')
  const deviceSize = computed(() => isDesktop.value ? 'desktop' : 'mobile');

  const slotNamePrefix = computed(() => position => $AD_SLOT_INFO[$AD_SOURCE][position][deviceSize.value].namePrefix);
  const adDimensions = computed(() => position => $AD_SLOT_INFO[$AD_SOURCE][position][deviceSize.value].dimensions);
  const adWidth = computed(() => position => adDimensions.value(position)[0]);
  const adHeight = computed(() => position => adDimensions.value(position)[1]);
  const slotName = computed(() => {
    return (position) => {
      const prefix = slotNamePrefix.value(position);

      return isAdsense.value ? `${prefix}${position}` : `${prefix}${primaryActivity.value}`;
    }
  });

  function registerAdSlot() {
    const adId = `banner-ad-${adSlots.size + 1}`;
    
    adSlots.set(adId, null);

    return adId;
  }

  function defineAdSlot(settings) {
    const accountId = $AD_SLOT_INFO[$AD_SOURCE].accountId
    const slot = slotName.value(settings.position);
    const dimensions = adDimensions.value(settings.position);

    window.googletag = window.googletag || { cmd: [] };
    
    googletag.cmd.push(() => {
      const adSlot = googletag
        .defineSlot(`/${accountId}/${slot}`, dimensions, settings.id)
        .addService(googletag.pubads());

      googletag.pubads().setCentering(false);
      googletag.pubads().disableInitialLoad();
      googletag.enableServices();

      adSlots.set(settings.id, adSlot)
    });
  }

  function loadAd(id) {
    googletag.cmd.push(() => {
      googletag.display(id)
      googletag.pubads().refresh([adSlots.get(id)])
    })    
  }

  function refreshAd(id) {
    if (!refreshAllowed.value) return;

    const adSlot = adSlots.get(id);

    if (!adSlot) return

    googletag.cmd.push(() => {
      googletag.pubads().refresh([adSlot])
    })

    blockRefresh();
  }  

  function blockRefresh(delay = 10000) {
    refreshAllowed.value = false

    setTimeout(() => {
      refreshAllowed.value = true
    }, delay)
  }

  return {
    adSlots,
    getAdSlot,
    deviceSize,
    adDimensions,
    slotName,
    adWidth,
    adHeight,
    registerAdSlot,
    defineAdSlot,
    loadAd,
    refreshAd
  }
})
